import { atom } from 'recoil';

export const confirmedGuardianDocument = atom<string | null>({
  key: 'confirmedGuardianDocument',
  default: null,
});
